module.exports = __webpack_public_path__ + "static/img/background.fdd828a8.jpg";